import React, { useState, useEffect } from 'react';
import './App.css';
import Photo from './components/Photo';
import Gallery from './components/Gallery';

function App() {
  const [currentView, setCurrentView] = useState<'capture' | 'gallery'>('capture');
  
  // Log current view changes to help with debugging
  useEffect(() => {
    console.log('Current view changed to:', currentView);
  }, [currentView]);

  return (
    <div className="App">
      <header className="App-header-small">
        <h1>Super1 Photo App</h1>
        <nav className="App-nav">
          <button 
            className={`nav-button ${currentView === 'capture' ? 'active' : ''}`}
            onClick={() => setCurrentView('capture')}
          >
            Capture Photo
          </button>
          <button 
            className={`nav-button ${currentView === 'gallery' ? 'active' : ''}`}
            onClick={() => setCurrentView('gallery')}
          >
            Gallery
          </button>
        </nav>
      </header>
      
      <main className="App-main">
        {currentView === 'capture' ? <Photo /> : <Gallery />}
      </main>
    </div>
  );
}

export default App;
